// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-r_ho","storyDetailHeaderDescription__time":"c-r_hp"};